import React from "react";

class Breakpoints extends React.Component {
  render() {
    return (
        <div>
          <div className="breakpoint sm">sm</div>
          <div className="breakpoint md">md</div>
          <div className="breakpoint lg">lg</div>
          <div className="breakpoint xl">xl</div>
        </div>
    );
  }
}

export default Breakpoints;
